import {
  ArrowLeftOutlined,
  ArrowUpOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  Divider,
  FloatButton,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Typography,
  Upload,
  theme,
  message,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Heading from "../../../components/common/heading";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import useTouchpoint from "../../../lib/hooks/useTouchpoint";
import { routes } from "../../../routes";
import { getQuestion } from "../../../services/customerTouchPoint";
import WithSidebar from "../../../templates/withSidebar";
import Validation from "./components/dataReport";
import APIEndpoint from "../../../services/endpoint";
import axios from "axios";
import { APPCONFIG } from "../../../Config";
import { downloadFile } from "../../../services/uploadFile";
import {Autocomplete} from "../../../components/common/autoCompleteV2";
import useMasterData from "../../../lib/hooks/useMasterData";
import {
  ACCESS_TOKEN,
  BUSINESS_REQUIRE,
  COMPANY_TYPE,
  CUSTOMER_EXPECT,
  CUSTOMER_SUPPORT,
  DATA_MASTER_DATA_TYPE,
  EXPECTED,
  INDUSTRY,
  INDUSTRY_TYPE,
  OTHER_BUSINESS_EXPECT,
  OTHER_PRODUCT_EXPECT,
  OTHER_SUPPORT_EXPECT,
  PRODUCT_REQUIREMENT,
  PROVICE,
  REGION_GROUP,
  SUCCESS_CODE,
  TOUCH_POINT_CHANNEL,
  VOC_MASTER_DATA_TYPE,
  WORK_PERIOD,
} from "../../../lib/const";

const { useToken } = theme;

const { Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;

export const AddTouchPointPage = () => {
  const { setQuestionValues, setHeaderValues, headerValues } = useTouchpoint();
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useToken();
  const [form] = Form.useForm();
  const { setOpenCancelModal } = useCancelModal();
  const [dataDetail, setDataDetail] = useState([]);
  const [agencyName, setAgencyName] = useState(location.state.agency_name);
  const [agencyType, setAgencyType] = useState(location.state.agency_type);
  const [vocDetail, setVocDetail] = useState(location.state.agency_detail?.vocDetail);
  const [agencyDetail, setAgencyDetail] = useState(
    location.state.agency_detail
  );
  const [agencyHeader, setAgencyHeader] = useState(
    location.state.agency_header
  );
  const [agencyChannel, setAgencyChannel] = useState(
    location.state.agency_channel
  );
  const [actionType, setActionType] = useState(location.state.action_type);
  const [actionSubType, setActionSubType] = useState(
    location.state.action_sub_type
  );
  const [header, setHeader] = useState(location.state.header);
  const [valueQ1, setValueQ1] = useState();

  const [valueQ3, setValueQ3] = useState();
  const [valueQ4, setValueQ4] = useState();

  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState("");

  const [fileList, setFileList] = useState([]);
  // const [fileList, setFileList] = useState("");
  // const [errMgeFile, setErrMgeFile] = useState("");
  // const [defaultFile, setDefaultFile] = useState([{ uid: "", name: "ยังไม่ได้เลือกไฟล์" }]);

  const [openModal, setOpenModal] = useState(false);

  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [chkData, setChkData] = useState(location.state.status_data);


   let k =0;

const [customerExpect] = useMasterData(VOC_MASTER_DATA_TYPE, CUSTOMER_EXPECT);

const [productRequirement] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    PRODUCT_REQUIREMENT
  );
 
const [customerSupport] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    CUSTOMER_SUPPORT
  );
  const [customerExpact, setCustomerExpact] = useState({
    type: "customer_expect",
    detail: [],
  });
 const [businessRequire] = useMasterData(
     VOC_MASTER_DATA_TYPE,
     BUSINESS_REQUIRE
   );
   const [otherProductExpect] = useMasterData(
      VOC_MASTER_DATA_TYPE,
      OTHER_PRODUCT_EXPECT
    );
    const [otherSupportExpect] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    OTHER_SUPPORT_EXPECT
  );
  const [otherBusinessExpect] = useMasterData(
     VOC_MASTER_DATA_TYPE,
     OTHER_BUSINESS_EXPECT
   );
  const [otherExpect, setOtherExpect] = useState({
    type: "other_expect",
    detail: [],
  });



  const onChangePage = () => {
    setOpenCancelModal(true);
  };

  const onFinish = async (values) => {
    setOpenModal(true);
    //    console.log(dataDetail[0]);

    let newValue = [];
    dataDetail.map((item, i) => {
      //  console.log(item.questionId);

      if (
        item.questionId ===
        dataDetail[0].questionId.substring(0, 6) + "-9999"
      ) {
        newValue.push({
          questionId: item.questionId,
          channel: item.channel,
          answer: form.getFieldValue(item.questionId),
        });
      } else {
        newValue.push({
          questionId: item.questionId,
          channel: item.channel,
          answer: form.getFieldValue(item.questionId),
        });
      }
    });

    if (actionType === "EDIT") {
      setQuestionValues(newValue);
    } else {
      if (valueQ1 == "ต่ำกว่ามาตรฐาน" || valueQ1 == "สูงกว่ามาตรฐาน") {
        setQuestionValues(newValue);
      } else {
        newValue.filter((item, i) => {
          if (
            item.questionId ===
            dataDetail[0].questionId.substring(0, 6) + "-0011"
          ) {
            newValue && newValue.splice(i, 1);
          }
        });
        setQuestionValues(newValue);
      }
    }

    /*
    console.log("values=>>>>");
    console.log(values);    
    let vocValue = [];
    vocValue.push({
      questionId: 1,
      answer:  Form.Item["productAndServiceWant"]
    });
    vocValue.push({
      questionId: 2,
      answer: Form.Item["productAndServiceWantSpecify"]
    });
    console.log("vocValue====>");
    console.log(vocValue);
    */

    setHeaderValues(header[0]);
const newVocDeetail = Object.fromEntries(
  Object.entries(values).filter(([key]) => !key.startsWith("q"))
);
    //("newValue", newValue);
    console.log("save voiceDetail ====>");
    console.log(newVocDeetail);

    const normalizeMap = (obj) => {
  if (!obj) return {};

  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [
      k,
      Array.isArray(v) ? v : (v ? [v] : [])
    ])
  );
};

[
  "productAndServiceWant",
  "productAndServiceExpected",
  "supportWant",
  "supportExpected",
  "transactionWant",
  "transactionExpected",
  "crmExpected"
].forEach(key => {
  newVocDeetail[key] = normalizeMap(newVocDeetail[key]);
});


    //set local question by id
    localStorage.setItem(
      agencyChannel,
      JSON.stringify({
        agencyType: agencyType,
        agencyChannel: agencyChannel,
        // questionID: newValue[0].questionId.substring(0, 6),
        questionDetail: newValue,
        vocDetail: newVocDeetail
      })
    );

    setSuccessModal(true);

    setTimeout(() => {
      navigate(routes.add_customer_touchpoint, {
        state: {
          action_type: actionType,
          edit_id: header[0].id ? header[0].id : "",
          status_data: chkData ? chkData : "",
        },
      });
    }, 1000);
  };

  const getQuestionData = useCallback(async () => {
    const res = await getQuestion(agencyType, agencyChannel);
    if (res.data.code === "0000") {
      // console.log(res.data.objectValue);
      setDataDetail(res.data.objectValue);
    }
  }, [dataDetail]);

  const onChange = (e) => {};

  const onChangeQ1 = (e) => {
    // console.log(e.target.value);
    setValueQ1(e.target.value);
  };

  const getDetail = useCallback(async () => {
    if (actionSubType === "PRE") {
      agencyDetail.questionDetail.map((item) => {
        form.setFields([
          {
            name: item.questionId,
            value: item.answer,
          },
        ]);
      });
      if (agencyDetail.questionDetail.length >= 8) {
        const res = await downloadFile(
          agencyDetail.questionDetail.length === 9
            ? agencyDetail.questionDetail[8].answer
            : agencyDetail.questionDetail.length === 8
            ? agencyDetail.questionDetail[7].answer
            : agencyDetail.questionDetail[6].answer
        );
        // setFileList([
        //   {
        //     index: 0,
        //     file: res ? res.data.objectValue.fileName : "",
        //     name: res ? res.data.objectValue.fileName : "",
        //     status: "done",
        //     uid:
        //       agencyDetail.questionDetail.length === 9
        //         ? agencyDetail.questionDetail[8].id
        //         : agencyDetail.questionDetail.length === 8
        //         ? agencyDetail.questionDetail[7].id
        //         : agencyDetail.questionDetail[6].id,
        //     url: "",
        //   },
        //]);
      }

      setValueQ1(
        agencyDetail.questionDetail.length === 9
          ? agencyDetail.questionDetail[0].answer
          : agencyDetail.questionDetail[0].answer
      );
    } else {
      if (chkData === "avilable_data") {
        //  console.log("EDIT POST", agencyDetail);
        agencyDetail.questionDetail.map((item) => {
          form.setFields([
            {
              name: item.questionId,
              value: item.answer,
            },
          ]);
        });
        //  console.log(agencyDetail.questionDetail.length);
        if (agencyDetail.questionDetail.length >= 8) {
          const res = await downloadFile(
            agencyDetail.questionDetail.length === 9
              ? agencyDetail.questionDetail[8].answer
              : agencyDetail.questionDetail.length === 8
              ? agencyDetail.questionDetail[7].answer
              : agencyDetail.questionDetail[6].answer
          );

          // setFileList([
          //   {
          //     index: 0,
          //     file: res ? res.data.objectValue.fileName : "",
          //     name: res ? res.data.objectValue.fileName : "",
          //     status: "done",
          //     uid:
          //       agencyDetail.questionDetail.length === 9
          //         ? agencyDetail.questionDetail[8].id
          //         : agencyDetail.questionDetail.length === 8
          //         ? agencyDetail.questionDetail[7].id
          //         : agencyDetail.questionDetail[6].id,
          //     url: "",
          //   },
          // ]);
        }

        setValueQ1(
          agencyDetail.questionDetail.length === 9
            ? agencyDetail.questionDetail[0].answer
            : agencyDetail.questionDetail[0].answer
        );
      }
    }
  }, [form]);

  const props = {
    beforeUpload: (file) => {
      const allowType =
        file.type === "image/jpeg" || file.type === "application/pdf";
      if (!allowType) {
        message.error(`${file.name} is not a  JPG, PDF file`);
      }
      return allowType || Upload.LIST_IGNORE;
    },
    onChange: (info) => {
      // console.log("info.fileList :: ", info.fileList);
    },
  };

  const onRemoveFile = (info, index) => {
    form.setFields([
      {
        name: ["filePath", index],
        value: "",
      },
    ]);
    let newData = fileList.filter((item) => item.index !== index);
    setFileList(newData);
  };

  const onUploadFile = async (info, index) => {
    const newObj = {
      index: index,
      file: info.file.name,
      name: info.file.name,
      status: "uploading",
      uid: info.file.uid,
      url: "",
    };

    let formData = new FormData();
    formData.append("file", info.file);

    const api = APIEndpoint.UPLOAD_FILE_API;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        "content-type": "multipart/form-data",
      },
    };
    const res = await axios.post(
      APPCONFIG.GATEWAY_ENDPOINT + api,
      formData,
      config
    );
    if (res?.data?.code === SUCCESS_CODE) {
      message.success(`${res.data.message}`);
      const { objectValue } = res.data;
      newObj.status = "done";
      //newObj.file = objectValue.fileName;
      //newObj.name = objectValue.fileName;

      if (fileList.length === 0) {
        setFileList([newObj]);
      } else {
        let newData = fileList.filter((item) => item.index !== index);
        newData.push(newObj);
        setFileList(newData);
      }

      if (dataDetail.length === 9) {
        form.setFields([
          {
            name: dataDetail[8]?.questionId,
            value: objectValue.filePath,
            errors: [],
          },
        ]);
      } else {
        form.setFields([
          {
            name: dataDetail[7]?.questionId,
            value: objectValue.filePath,
            errors: [],
          },
        ]);
      }
    } else {
      newObj.status = "error";

      message.error(`${res.data.message}`);
    }
  };

  useEffect(() => {
    if (actionType === "EDIT") {
      getQuestionData();
      getDetail();
    } else {
      getQuestionData();
      setHeaderValues(header[0]);
      getDetail();
    }
console.log("vocDetail to set ===>");
console.log(vocDetail)
const flatOrNull = (obj) => {
  const arr = Object.values(obj ?? {}).flat();
   if(arr==""){
     return null;
   }
  return arr.length ? arr : null;
};
const flatText = (obj) => {
  return obj ;
  return Object.values(obj ?? {})[0] ?? "";
};
if(vocDetail){
// form.setFieldsValue({
//     productAndServiceWant:  Object.values(vocDetail.productAndServiceWant ?? {}).flat()
// });
// form.setFieldsValue({
//     productAndServiceExpected: Object.values(vocDetail.productAndServiceExpected ?? {}).flat()
// });

// form.setFieldsValue({
//     transactionWant:  Object.values(vocDetail.transactionWant ?? {}).flat()
// });
// form.setFieldsValue({
//     transactionExpected:  Object.values(vocDetail.transactionExpected ?? {}).flat()
// });

// form.setFieldsValue({
//     supportWant:  Object.values(vocDetail.supportWant ?? {}).flat()
// });
// form.setFieldsValue({
//     supportExpected:  Object.values(vocDetail.supportExpected ?? {}).flat()
// });

// form.setFieldsValue({
//     crmExpected:  Object.values(vocDetail.crmExpected ?? {}).flat()
// });


form.setFieldsValue({
  productAndServiceWant: flatOrNull(vocDetail.productAndServiceWant),
  productAndServiceExpected: flatOrNull(vocDetail.productAndServiceExpected),
  transactionWant: flatOrNull(vocDetail.transactionWant),
  transactionExpected: flatOrNull(vocDetail.transactionExpected),
  supportWant: flatOrNull(vocDetail.supportWant),
  supportExpected: flatOrNull(vocDetail.supportExpected),
  crmExpected: flatOrNull(vocDetail.crmExpected),
  productAndServiceSuggestion: flatText(vocDetail.productAndServiceSuggestion),
  supportSuggestion: flatText(vocDetail.supportSuggestion),
  transactionSuggestion: flatText(vocDetail.transactionSuggestion),
  crmSuggestion: flatText(vocDetail.crmSuggestion),
  notSatisfied: flatText(vocDetail.notSatisfied),
});


// form.setFieldsValue({
//     productAndServiceSuggestion:    Object.values(vocDetail.productAndServiceSuggestion  ?? {}).flat()
// });

// form.setFieldsValue({
//     supportSuggestion:    Object.values(vocDetail.supportSuggestion  ?? {}).flat()
// });
// form.setFieldsValue({
//     transactionSuggestion:    Object.values(vocDetail.transactionSuggestion  ?? {}).flat()
// });
// form.setFieldsValue({
//     crmSuggestion:    Object.values(vocDetail.crmSuggestion  ?? {}).flat()
// });
// form.setFieldsValue({
//     notSatisfied:    Object.values(vocDetail.notSatisfied  ?? {}).flat()
// });
console.log("set value Finish");
}

  }, [location, getDetail]);

  // useEffect(() => {
  //     console.log("actionType=>", actionType);
  //     console.log("actionSubType=>", actionSubType);
  //     console.log("chkData=>", chkData);
  //     console.log("agencyType", Validation.convertInst(agencyType));
  //     console.log("agencyHeader", agencyHeader.replaceAll("\n", "<br/>"));
  //     console.log("headerValues", headerValues);
  //     console.log("agencyName", agencyName);
  // }, [actionType, actionSubType, chkData, agencyType, agencyHeader]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"รายละเอียด"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูล Touch point ",
                },
                {
                  title: (
                    <span onClick={onChangePage} style={{ cursor: "pointer" }}>
                      รายละเอียด
                    </span>
                  ),
                },
                {
                  title: (
                    <span className="pr_green">
                      {Validation.convertInst(agencyType)}
                    </span>
                  ),
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button onClick={() => setOpenCancelModal(true)}>
                      ยกเลิก
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      // disabled={!submittable}
                      // loading={loading}
                    >
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>
              <Row gutter={[8, 16]} className="card">
                <Col span={24}>
                  <Heading
                    text={agencyName}
                    size={4}
                    style={{ margin: 0, color: "#499D96" }}
                  />
                </Col>
                <Col span={16}>
                  <Text style={{ whiteSpace: "pre-line" }}>{agencyHeader}</Text>
                </Col>
              </Row>

              <Row gutter={[8, 16]} className="card" style={{ marginTop: 10 }}>
                <Col span={24}>
                  <Heading
                    text={"ผลการดำเนินงานตามมาตรฐานการให้บริการ"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                </Col>
                <Col span={16}>
                  <Form.Item
                    label={"1. " + dataDetail[0]?.question}
                    name={dataDetail[0]?.questionId}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Radio.Group onChange={onChangeQ1} defaultValue={valueQ1}>
                      <Space direction="vertical">
                        <Radio
                          value={dataDetail[0]?.choice1}
                          style={{ paddingBottom: 5 }}
                        >
                          <Text
                            style={{
                              fontSize: 14,
                              fontWeight: 500,
                              color: "#667085",
                            }}
                          >
                            {dataDetail[0]?.choice1}
                          </Text>
                        </Radio>
                        <Radio
                          value={dataDetail[0]?.choice2}
                          style={{ paddingBottom: 5 }}
                        >
                          <Text
                            style={{
                              fontSize: 14,
                              fontWeight: 500,
                              color: "#667085",
                            }}
                          >
                            {dataDetail[0]?.choice2}
                          </Text>
                        </Radio>
                        <Radio
                          value={dataDetail[0]?.choice3}
                          style={{ paddingBottom: 5 }}
                        >
                          <Text
                            style={{
                              fontSize: 14,
                              fontWeight: 500,
                              color: "#667085",
                            }}
                          >
                            {dataDetail[0]?.choice3}
                          </Text>
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                <>
                  {(valueQ1 == "ต่ำกว่ามาตรฐาน" ||
                    valueQ1 == "สูงกว่ามาตรฐาน") && (
                    <>
                      <Col span={16}>
                        <Form.Item
                          label={"2. ปัญหาอุปสรรค (ถ้ามี)"}
                          name={dataDetail[1]?.questionId}
                        >
                          <TextArea
                            placeholder="รายละเอียด"
                            name={dataDetail[1]?.questionId}
                            style={{ height: 80 }}
                          ></TextArea>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </>

                {Validation.convertInst(agencyType) === "กองสื่อสารองค์กร" ||
                Validation.convertInst(agencyType) === "กองการตลาด" ||
                Validation.convertInst(agencyType) ===
                  "ฝ่ายบริหารผู้ประกอบการ" ||
                (Validation.convertInst(agencyType) ===
                  "สำนักงานนิคมอุตสาหกรรม" &&
                  (agencyName === "Line กลุ่มผู้ประกอบการ" ||
                    agencyName === "โทรศัพท์ สำนักงานนิคมอุตสาหกรรม" ||
                    agencyName ===
                      "ศูนย์บริการเบ็ดเสร็จครบวงจร (Total Solution Center : TSC)  / สำนักงานนิคมอุตสาหกรรม)")) ? (
                  <>
                    <Divider dashed style={{ margin: "0px 0px 0px 0px" }} />
                    <Col span={24}>
                      <Heading
                        text={"สารสนเทศของลูกค้า ที่ได้รับจากช่องทางนั้นๆ"}
                        size={4}
                        style={{ margin: 0, color: token.thPrimary }}
                      />
                    </Col>
                    {dataDetail.length === 9 && (
                    <Col span={18}>
                    <Form.Item
                        label={ "1. " + dataDetail[7]?.question}
                        name={dataDetail[7]?.questionId}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        {/* <Input placeholder="" name={"factoryName"} /> */}
                        <Autocomplete
                            subject="eppFactory"
                              valueField="MerchantNameTH"
                              placeholder="ชื่อบริษัท"
                          />
                      </Form.Item>
                    </Col>
                  )}
                    <Col span={18}>
                    
                      <Form.Item
                        label={
                          dataDetail.length === 9
                            ? "2. " + dataDetail[2]?.question
                            : dataDetail.length === 8 
                            ?  "1. " + dataDetail[2]?.question
                            : "2. " + dataDetail[1]?.question
                        }
                        name={
                          dataDetail.length === 9
                            ? dataDetail[2]?.questionId
                            : dataDetail.length === 8
                            ? dataDetail[2]?.questionId
                            : dataDetail[1]?.questionId
                        }
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Radio.Group onChange={onChange} defaultValue={valueQ3}>
                          <Space direction="vertical">
                            <Radio
                              value={
                                dataDetail.length === 9
                                  ? dataDetail[2]?.choice1
                                : dataDetail.length === 8
                                  ? dataDetail[2]?.choice1
                                  : dataDetail[1]?.choice1
                              }
                              style={{ paddingBottom: 5 }}
                            >
                              <Text
                                style={{
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#667085",
                                }}
                              >
                                {dataDetail.length === 9
                                  ? dataDetail[2]?.choice1
                                  : dataDetail.length === 8
                                  ? dataDetail[2]?.choice1
                                  : dataDetail[1]?.choice1}
                              </Text>
                            </Radio>
                            <Radio
                              value={
                                dataDetail.length === 9
                                  ? dataDetail[2]?.choice2
                                  : dataDetail.length === 8
                                  ? dataDetail[2]?.choice2
                                  : dataDetail[1]?.choice2
                              }
                              style={{ paddingBottom: 5 }}
                            >
                              <Text
                                style={{
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#667085",
                                }}
                              >
                                {dataDetail.length === 9
                                  ? dataDetail[2]?.choice2
                                  : dataDetail.length === 8
                                  ? dataDetail[2]?.choice2
                                  : dataDetail[1]?.choice2}
                              </Text>
                            </Radio>
                            <Radio
                              value={
                                dataDetail.length === 9
                                  ? dataDetail[2]?.choice3
                                  : dataDetail.length === 8
                                  ? dataDetail[2]?.choice3
                                  : dataDetail[1]?.choice3
                              }
                              style={{ paddingBottom: 5 }}
                            >
                              <Text
                                style={{
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#667085",
                                }}
                              >
                                {dataDetail.length === 9
                                  ? dataDetail[2]?.choice3
                                  : dataDetail.length === 8
                                  ? dataDetail[2]?.choice3
                                  : dataDetail[1]?.choice3}
                              </Text>
                            </Radio>
                            <Radio
                              value={
                                dataDetail.length === 9
                                  ? dataDetail[2]?.choice4
                                  : dataDetail.length === 8
                                  ? dataDetail[2]?.choice4
                                  : dataDetail[1]?.choice4
                              }
                              style={{ paddingBottom: 5 }}
                            >
                              <Text
                                style={{
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#667085",
                                }}
                              >
                                {dataDetail.length === 9
                                  ? dataDetail[2]?.choice4
                                  : dataDetail.length === 8
                                  ? dataDetail[2]?.choice4
                                  : dataDetail[1]?.choice4}
                              </Text>
                            </Radio>
                            <Radio
                              value={
                                dataDetail.length === 9
                                  ? dataDetail[2]?.choice5
                                  : dataDetail.length === 8
                                  ? dataDetail[2]?.choice5
                                  : dataDetail[1]?.choice5
                              }
                              style={{ paddingBottom: 5 }}
                            >
                              <Text
                                style={{
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#667085",
                                }}
                              >
                                {dataDetail.length === 9
                                  ? dataDetail[2]?.choice5
                                  : dataDetail.length === 8
                                  ? dataDetail[2]?.choice5
                                  : dataDetail[1]?.choice5}
                              </Text>
                            </Radio>
                          </Space>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    <Col span={18}>
                      <Form.Item
                        label={
                          dataDetail.length === 9
                            ? "3. " + dataDetail[3]?.question
                          : dataDetail.length === 8
                            ? "2. " + dataDetail[3]?.question
                            : "3. " + dataDetail[2]?.question
                        }
                        name={
                          dataDetail.length === 9
                            ? dataDetail[3]?.questionId
                          : dataDetail.length === 8
                            ? dataDetail[3]?.questionId
                            : dataDetail[2]?.questionId
                        }
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Radio.Group onChange={onChange} defaultValue={valueQ4}>
                          <Space direction="vertical">
                            <Radio
                              value={
                                dataDetail.length === 9
                                  ? dataDetail[3]?.choice1
                                :  dataDetail.length === 8
                                  ? dataDetail[3]?.choice1
                                  : dataDetail[2]?.choice1
                              }
                              style={{ paddingBottom: 5 }}
                            >
                              <Text
                                style={{
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#667085",
                                }}
                              >
                                {dataDetail.length === 9
                                  ? dataDetail[3]?.choice1
                                  :  dataDetail.length === 8
                                  ? dataDetail[3]?.choice1
                                  : dataDetail[2]?.choice1}
                              </Text>
                            </Radio>
                            <Radio
                              value={
                                dataDetail.length === 9
                                  ? dataDetail[3]?.choice2
                                  :  dataDetail.length === 8
                                  ? dataDetail[3]?.choice2
                                  : dataDetail[2]?.choice2
                              }
                              style={{ paddingBottom: 5 }}
                            >
                              <Text
                                style={{
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#667085",
                                }}
                              >
                                {dataDetail.length === 9
                                  ? dataDetail[3]?.choice2
                                  :  dataDetail.length === 8
                                  ? dataDetail[3]?.choice2
                                  : dataDetail[2]?.choice2}
                              </Text>
                            </Radio>
                            <Radio
                              value={
                                dataDetail.length === 9
                                  ? dataDetail[3]?.choice3
                                  :  dataDetail.length === 8
                                  ? dataDetail[3]?.choice3
                                  : dataDetail[2]?.choice3
                              }
                              style={{ paddingBottom: 5 }}
                            >
                              <Text
                                style={{
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#667085",
                                }}
                              >
                                {dataDetail.length === 9
                                  ? dataDetail[3]?.choice3
                                  :  dataDetail.length === 8
                                  ? dataDetail[3]?.choice3
                                  : dataDetail[2]?.choice3}
                              </Text>
                            </Radio>
                          </Space>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
{/*                    
                    <Col span={16}>
                      <Form.Item
                        label={
                          dataDetail.length === 9
                            ? "4. " + dataDetail[4]?.question
                          :  dataDetail.length === 8
                            ? "3. " + dataDetail[4]?.question
                            : "4. " + dataDetail[3]?.question
                        }
                        name={
                          dataDetail.length === 9
                            ? dataDetail[4]?.questionId
                          :  dataDetail.length === 8
                            ? dataDetail[4]?.questionId
                            : dataDetail[3]?.questionId
                        }
                      >
                        <TextArea
                          placeholder="รายละเอียด"
                          name={"detail3"}
                          style={{ height: 80 }}
                        ></TextArea>
                      </Form.Item>
                    </Col>

                    <Col span={16}>
                      <Form.Item
                        label={
                          dataDetail.length === 9
                            ? "5. " + dataDetail[5]?.question
                          :  dataDetail.length === 8
                            ? "4. " + dataDetail[5]?.question
                            : "5. " + dataDetail[4]?.question
                        }
                        name={
                          dataDetail.length === 9
                            ? dataDetail[5]?.questionId
                          :  dataDetail.length === 8
                            ? dataDetail[5]?.questionId
                            : dataDetail[4]?.questionId
                        }
                      >
                        <TextArea
                          placeholder="รายละเอียด"
                          name={"detail4"}
                          style={{ height: 80 }}
                        ></TextArea>
                      </Form.Item>
                    </Col>
 
                        <Col span={16}>
                      <Form.Item
                        label={
                          dataDetail.length === 9
                            ? "6. " + dataDetail[6]?.question
                          :  dataDetail.length === 8
                            ? "5. " + dataDetail[6]?.question
                            : "6. " + dataDetail[5]?.question
                        }
                        name={
                          dataDetail.length === 9
                            ? dataDetail[6]?.questionId
                          :  dataDetail.length === 8
                            ? dataDetail[6]?.questionId
                            : dataDetail[5]?.questionId
                        }
                      >
                        <TextArea
                          placeholder="รายละเอียด"
                          name={"detail5"}
                          style={{ height: 80 }}
                        ></TextArea>
                      </Form.Item>
                    </Col>
*/}
                    <Col span={16}>
{/*
                      <Form.Item
                        label="แนบไฟล์"
                        name={
                          dataDetail.length === 9
                            ? dataDetail[8]?.questionId
                          :  dataDetail.length === 8
                            ? dataDetail[7]?.questionId
                            : dataDetail[6]?.questionId
                        }
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                        // required={true}
                        // rules={[

                        //     () => ({
                        //         validator(_, value) {
                        //             console.log("value=>", value);
                        //             console.log(fileList);
                        //             if (value === undefined) {
                        //                 return Promise.reject(new Error("โปรดระบุ"));
                        //                 // if (defaultFile.length > 0 && defaultFile[0].name != "ยังไม่ได้เลือกไฟล์") {
                        //                 //     if (errMgeFile != "") {
                        //                 //         return Promise.reject(new Error(""));
                        //                 //     } else {
                        //                 //         return Promise.resolve();
                        //                 //     }
                        //                 // } else {
                        //                 //     return Promise.reject(new Error("โปรดระบุ"));
                        //                 // }
                        //             } else {
                        //                 return Promise.resolve();
                        //             }
                        //         },
                        //     }),
                        // ]}
                      >
                        
                        <Upload
                          accept="image/jpg,image/jpeg,application/pdf"
                          {...props}
                          customRequest={(e) => {
                            onUploadFile(e, 0);
                          }}
                          onRemove={(info) => {
                            onRemoveFile(info, 0);
                          }}
                          fileList={
                            fileList.length > 0
                              ? fileList.filter(
                                  (obj, index) =>
                                    fileList.findIndex(
                                      (item) =>
                                        item.uid === obj.uid && item.index === 0
                                    ) === index
                                )
                              : undefined
                          }
                          multiple={false}
                        >
                          <Button icon={<UploadOutlined />}>เลือกไฟล์</Button>
                        </Upload>
                        <span style={{ color: "#667085", fontSize: 13 }}>
                          สามารถ Upload File ได้ 1 File รองรับนามสกุล JPG, PDF
                          ขนาดไม่เกิน 50 Mb
                        </span>
                      </Form.Item>
*/}

                      {/* <Form.Item
                                                name={dataDetail[7]?.questionId}
                                                label={"แนบไฟล์"}
                                                required={true}
                                                rules={[
                                                    () => ({
                                                        validator(_, value) {
                                                            if (value === undefined) {
                                                                if (defaultFile.length > 0 && defaultFile[0].name != "ยังไม่ได้เลือกไฟล์") {
                                                                    if (errMgeFile != "") {
                                                                        return Promise.reject(new Error(""));
                                                                    } else {
                                                                        return Promise.resolve();
                                                                    }
                                                                } else {
                                                                    return Promise.reject(new Error("โปรดระบุ"));
                                                                }
                                                            } else {
                                                                return Promise.resolve();
                                                            }
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Space>
                                                    <Upload
                                                        maxCount={1}
                                                        accept="image/jpg,image/jpeg,application/pdf"
                                                        onChange={(value) => handleReaderImageFiles(value)}
                                                        customRequest={(data) => customRequestImage(data)}
                                                        showUploadList={false}
                                                        fileList={defaultFile}
                                                    >
                                                        <Button
                                                            style={{
                                                                width: 100,
                                                                height: 40,
                                                                borderRadius: "6px 0px 0px 6px",
                                                                backgroundColor: "#6442A4",
                                                            }}
                                                        >
                                                            <Text style={{ color: "white" }}>เลือกไฟล์</Text>
                                                        </Button>
                                                    </Upload>
                                                    <div
                                                        style={{
                                                            marginLeft: -9,
                                                            width: 379,
                                                            height: 40,
                                                            borderRadius: "0px 6px 6px 0px",
                                                            backgroundColor: "#F4F6FC",
                                                            border: "none",
                                                        }}
                                                    >
                                                        <div style={{ padding: "10px 0px 0px 10px" }}>
                                                            {defaultFile[0] ? defaultFile[0].name.fileName : ""}
                                                        </div>
                                                    </div>
                                                </Space>
                                            </Form.Item>
                                            {errMgeFile != "" ? (
                                                <>
                                                    <Col span={16} style={{ paddingTop: 10 }}>
                                                        <Text
                                                            style={{
                                                                fontSize: 14,
                                                                fontWeight: 500,
                                                                color: "red",
                                                            }}
                                                        >
                                                            {errMgeFile}
                                                        </Text>
                                                    </Col>
                                                </>
                                            ) : (
                                                <></>
                                            )}

                                            <Col span={16} style={{ paddingTop: 10 }}>
                                                <Text
                                                    style={{
                                                        fontSize: 14,
                                                        fontWeight: 500,
                                                        color: "#667085",
                                                    }}
                                                >
                                                    สามารถ Upload File ได้ 1 File รองรับนามสกุล JPG, PDF ขนาดไม่เกิน 50 Mb
                                                </Text>
                                            </Col> */}
                    </Col>
{/* Inser New  NEW SECTION +++ VOC*/}
 <Col span={24}>
        <Divider dashed />
      </Col>
       <Col span={24}>
          <Heading
            text={"Voice of Customer"}
            size={4}
            style={{ margin: 0, color: token.thPrimary }}
          />
          <Divider />
        </Col>
                         

                          <Col span={24}>
                            <div style={{ fontWeight: 600, fontSize: 16 }}>
                              ด้านผลิตภัณฑ์และบริการ
                            </div>
                          </Col>

                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["productAndServiceWant", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                mode="multiple"
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {productRequirement &&
                                  productRequirement.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["productAndServiceWant", k]) &&
                              form
                                .getFieldValue(["productAndServiceWant", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={[
                                    "productAndServiceWantSpecify",
                                    `${k}`,
                                  ]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["productAndServiceExpected", `${k}`]}
                            >
                              <Select
                                allowClear
                                mode="multiple"
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {otherProductExpect &&
                                  otherProductExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue([
                              "productAndServiceExpected",
                              k,
                            ]) &&
                              form
                                .getFieldValue(["productAndServiceExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={[
                                    "productAndServiceExpectedSpecify",
                                    `${k}`,
                                  ]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>

                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              ด้านสนับสนุนลูกค้า
                            </div>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["supportWant", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {customerSupport &&
                                  customerSupport.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["supportWant", k]) &&
                              form
                                .getFieldValue(["supportWant", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["supportWantSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["supportExpected", `${k}`]}
                            >
                              <Select
                                allowClear
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {otherSupportExpect &&
                                  otherSupportExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["supportExpected", k]) &&
                              form
                                .getFieldValue(["supportExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["supportExpectedSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>

                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              ด้านการทำธุรกรรม
                            </div>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["transactionWant", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                              >
                                {businessRequire &&
                                  businessRequire.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["transactionWant", k]) &&
                              form
                                .getFieldValue(["transactionWant", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["transactionWantSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["transactionExpected", `${k}`]}
                            >
                              <Select
                                allowClear
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                                maxTagCount={"responsive"}
                                mode={"multiple"}
                              >
                                {otherBusinessExpect &&
                                  otherBusinessExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["transactionExpected", k]) &&
                              form
                                .getFieldValue(["transactionExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["transactionExpectedSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>

                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              ด้านการจัดการความสัมพันธ์ (CRM)
                            </div>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ/คาดหวัง ด้านการจัดการความสัมพันธ์(CRM) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["crmExpected", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                              >
                                {customerExpect &&
                                  customerExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["crmExpected", k]) &&
                              form
                                .getFieldValue(["crmExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["crmExpectedSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ข้อเสนอแนะด้านผลิตภัณฑ์และบริการ (ถ้ามี)"
                              name={["productAndServiceSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด" />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="3.ข้อเสนอแนะด้านสนับสนุนลูกค้า (ถ้ามี)"
                              name={["supportSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด" />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="4.ข้อเสนอแนะด้านการทำธุรกรรม (อนุมัติ, อนุญาตและสิทธิประโยชน์) (ถ้ามี)"
                              name={["transactionSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด" />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="5.ข้อเสนอแนะด้านการจัดการความสัมพันธ์กับลูกค้า (CRM) (ถ้ามี)"
                              name={["crmSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด" />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="6.สิ่งที่ไม่พึ่งพอใจต้องการให้ปรับปรุงอย่างเร่งด่วน (ถ้ามี)"
                              name={["notSatisfied", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด" />
                            </Form.Item>
                          </Col>

{/* End Insert New */}
                
                  </>
                ) : (
                  <></>
                 
                )}
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
      <FloatButton.BackTop
        className="custom-float-btn"
        icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
        shape="square"
        style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
      />
    </WithSidebar>
  );
};
